import { loadRoomRequest } from "../../../../common/fullvideolib/userActionEvents"
import { i18n } from "../../../../common/translation"
import { isRoomRoomlistSpaEligiblePage } from "../../../components/roomlist/spaHelpers"
import { MobileSearchPaneSuggestedItem, MobileSearchSuggestionClicked } from "./mobileSearchPaneSuggestedItem"
import type { ISuggestionProps } from "../baseSuggestedItem"

export class MobileSearchPaneOnlineSuggestedItem extends MobileSearchPaneSuggestedItem {
    protected getIconClassName(): string {
        return "icon-online"
    }

    protected getStatusText(): string {
        return i18n.broadcastingNow
    }

    protected getRowClassName(): string {
        return "broadcasterSuggestion"
    }

    protected onClickHandler(props: ISuggestionProps, evt?: MouseEvent): void {
        super.onClickHandler(props, evt)
        if (isRoomRoomlistSpaEligiblePage()) {
            evt?.preventDefault()
            loadRoomRequest.fire(props.labelText)
        }
        MobileSearchSuggestionClicked.fire()
    }
}
